export function requestNotificationPermission (){
    if (window.Notification && Notification.permission !== "granted") {
        Notification.requestPermission().then(function(result) {
            console.log(result);
          });

    }
}
export function showNotification(title, text, force=false){
    if (document.visibilityState === 'visible' && !force) 
        return;
    
    if (window.Notification && Notification.permission === "granted") {
        var n = new Notification(title, { body: text});
    }

}